import React, { useState } from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import { useNavigate } from 'react-router-dom'
import type { State } from 'types/redux'
import { clientLibraryListCreate } from '@disco/state-management/actions/client-library-list-actions'
import DocumentHeadTags from 'components/document-head-tags'
import Button from 'components/ui/button'
import ButtonContainer from 'components/ui/button-container'
import ErrorText from 'components/ui/error-text'
import Heading from 'components/ui/heading'
import ModalWindow from 'components/ui/modal-window'
import TextField from 'components/ui/text-field'

const LibrariesCreate = (): React.ReactNode => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [name, setName] = useState('')
  const error = useSelector((state: State) => state.clientLibraries.list.errors)

  const handleCancel = () => navigate(-1)

  const handleSubmit = (event: React.SyntheticEvent<any>) => {
    event.preventDefault()
    dispatch(
      clientLibraryListCreate({
        name,
      }),
    )
  }

  return (
    <ModalWindow
      header={<Heading size={700}>Create New Catalog</Heading>}
      footer={
        error?.non_field_errors && (
          <ErrorText>{error.non_field_errors}</ErrorText>
        )
      }
      actions={
        <ButtonContainer>
          <Button caption="Cancel" onClick={handleCancel} />
          <Button
            appearance="primary"
            caption="Save"
            disabled={!name}
            onClick={handleSubmit}
          />
        </ButtonContainer>
      }
      isOpen={true}
      onClose={handleCancel}
    >
      <DocumentHeadTags title="Create New Catalog | DISCO" />
      <TextField
        autoFocus
        error={error?.name}
        label="Name"
        value={name}
        onChange={event => setName(event.target.value)}
      />
    </ModalWindow>
  )
}

export default LibrariesCreate
